module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-xs-4",
    class: {
      active: _vm.boxConfig.trigger_button.kind === 'naked'
    },
    on: {
      "click": function($event) {
        return _vm.boxUpdateConfig({
          item: 'trigger_button',
          key: 'kind',
          value: 'naked'
        })
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "kp-tab-label"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.button'))), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.without_style')))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kp-btn-action-lg-max",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "kp-panel-btn-naked"
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-415f0030!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/options/Naked.vue
 ** module id = 809
 ** module chunks = 1
 **/